import { Component, Output, EventEmitter, ViewChildren,
  OnInit, OnChanges, SimpleChanges, QueryList, Input } from '@angular/core';
import { IFilterOption, ExpansorWithChipComponent,
  ISelectedValue } from '../shared-components/expansor-with-chip/expansor-with-chip.component';
import { MediaService } from '../shared-services/media.service';
import { ApiService } from '../core/api.service';
import { ExpansorWithChipMultipleComponent, IOption } from '../shared-components/expansor-with-chip-multiple/expansor-with-chip-multiple.component';
import { ExpansorWithSearchComponent } from '../shared-components/expansor-with-search/expansor-with-search.component';
import * as moment from 'moment';
import { Parametric } from '../cliente/parametric.model';
import { Tag } from '../cliente/tag.model';

export interface ISelectedChip {
  chipKey: string;
  chipLabel: string;
  categoryName: string;
  tagId: any;
  selectedChipFilterComponent: any; // Componente del viewChild
}

export interface DocChangeResponse {
  selectedChips: ISelectedChip[];
  selectedDocs: Parametric[];
}

export interface GenericFilter {
  id: number;
  label: string;
  selected: boolean;
  filter: string;
}


@Component({
  selector: 'app-acuerdo-filter',
  styleUrls: ['./acuerdo-filter.component.scss'],
  templateUrl: './acuerdo-filter.component.html',
})
export class AcuerdoFilterComponent implements OnInit, OnChanges {
  isMobile: boolean;

  fechaAcuerdo: string;
  ultimaConexion: string;
  ultimaCompra: string;
  estado: Parametric;

  @Input() showEstado = true;
  @Input() selectedChips: ISelectedChip[] = [];
  private estados: Parametric[];

  estadoFilterValues: IFilterOption[] = [];
  ultimaConexionFilterValues: IFilterOption[] = [];
  ultimaCompraFilterValues: IFilterOption[] = [];

  @ViewChildren('fechaAcuerdoFilter') private fechaAcuerdoComponent: ExpansorWithSearchComponent;
  @ViewChildren('estadoFilter') private estadoComponent: ExpansorWithChipMultipleComponent<Tag>;
  @Output() onFilterChange = new EventEmitter<ISelectedChip[]>();
  @Output() onHide = new EventEmitter<void>();

  async getEstados() {
    this.apiService.get(Parametric, Parametric.path + 'estados_acuerdos/', null).toPromise().then(value => {
      this.estados = value;
      for (const estado of this.estados){
        this.estadoFilterValues.push({value: estado.id.toString(), displayText: estado.description, class: ''});
      }
    });
  }

  constructor(
    private mediaService: MediaService,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    this.mediaService.isMobile.subscribe(isMobile => this.isMobile = isMobile);
    this.getEstados();
  }

  ngOnChanges(changes: SimpleChanges) {}

  onRemoveChip(selectedChip: ISelectedChip) {
    selectedChip.selectedChipFilterComponent.onRemoveChip();
    this.selectedChips = this.selectedChips.filter(x => x.chipKey !== selectedChip.chipKey);
    this.filterChange();
  }

  onFechaAcuerdoChange(selectedFilter: ISelectedValue) {
    const val = (selectedFilter.value as string).split('/');
    selectedFilter.value = moment(new Date(val['2'], val['1'] - 1, val['0'])).format('YYYY-MM-DD');
    this.addChip('fechaAcuerdoFilter', selectedFilter.viewValue, selectedFilter, this.fechaAcuerdoComponent);
    this.fechaAcuerdo = selectedFilter.value;
    this.filterChange();
  }

  onEstadoChange(selectedFilter: ISelectedValue) {
    this.addChip('estadoFilter', selectedFilter.viewValue, selectedFilter, this.estadoComponent);
    this.estado = selectedFilter.value;
    this.filterChange();
  }

  addMultipleChip(chips: any[], categoryName: string, chipName: string, component: ExpansorWithChipMultipleComponent<Tag>) {
    this.selectedChips = this.selectedChips.filter(x => x.categoryName !== categoryName);

    for (const chip of chips) {
      const chipKey = chipName + chip.value;

      if (!this.selectedChips.find(x => x.chipKey === chipKey)) {
        const selectedFilter = { value: chip.value, categoryName: categoryName, viewValue: chip.displayText };
        this.addChip(chipKey, chip.displayText, selectedFilter, component);
      }
    }
  }

  filterChange() {
    this.onFilterChange.emit(this.selectedChips);
  }

  addChip(chipKey: string, chipLabel: string, selectedFilter: ISelectedValue, selectedChipFilterComponent: any): ISelectedChip {
    if (selectedFilter.value === undefined) {
      return;
    }

    if (this.selectedChips.find(x => x.chipKey === chipKey)) {
      return;
    }

    const selectedChipInstance: ISelectedChip =  {
      chipKey: chipKey,
      chipLabel: chipLabel,
      categoryName: selectedFilter.categoryName,
      tagId: selectedFilter.tagID !== undefined ? selectedFilter.tagID : selectedFilter.value,
      selectedChipFilterComponent: (<QueryList<ExpansorWithChipComponent>>selectedChipFilterComponent).first
    };

    this.selectedChips.push(selectedChipInstance);
  }

  onTogglePickerFrom(event: any) {
    event.stopPropagation();
  }

  onTogglePickerTo(event: any) {
    event.stopPropagation();
  }

  getFechaReciente() {
    return this.getFecha(3);
  }

  getFechaHacePoco() {
    return this.getFecha(15);
  }
  getFechaHaceMucho() {
    return this.getFecha(60);
  }

  getFecha(val: number) {
    const d = new Date();
    d.setDate(new Date().getDate() - val);
    return moment(d).format('YYYY-MM-DD');
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo-filter.component.ts